module.exports = __webpack_public_path__ + "static/media/ETH-USDT.81fc2551.png";